export default __webpack_public_path__ + "static/media/urskog-skate.e2897c78.jpeg";